<template>
  <div class="add" v-loading="loading">
    <back />
    <div class="form">
      <!-- <el-row> -->
      <!-- <el-col :span="16"> -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-form-inline" :disabled="id ? true : false">
        <el-form-item label="消息名称" prop="textName">
          <el-input v-model="ruleForm.textName" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="text">
          <el-input v-model="ruleForm.text" type="textarea" placeholder="请输入内容" :rows="6" maxlength="20" show-word-limit resize="none"></el-input>
        </el-form-item>
      </el-form>
      <!-- </el-col> -->
      <!-- </el-row> -->
    </div>

    <div class="list">
      <div class="head">
        <div class="left">
          <div class="label">发送渠道</div>
          <div class="msg_type">
            <el-radio-group v-model="sendType" :disabled="id ? true : false">
              <el-radio :label="0">小程序</el-radio>
              <el-radio :label="1">公众号</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="head">
        <div class="left">
          <div class="label">联系人</div>
          <div class="msg_type">
            <el-radio-group v-model="msgType" :disabled="id ? true : false">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">指定</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="right" v-show="msgType == 1 && !id">
          <el-button class="btn" type="primary" size="small" @click="onSelect">选择联系人</el-button>
        </div>
      </div>
      <div class="divider" v-show="msgType == 1">
        <el-divider></el-divider>
      </div>
      <div class="g_table" style="padding: 0 30px" v-if="msgType == 1">
        <el-table :data="ruleForm.userIdList" style="width: 100%" max-height="540">
          <el-table-column prop="number" label="序号" width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="nickName" label="用户昵称"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="150" prop="userCode" label="用户编号"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="150" prop="gender" label="用户性别">
            <template slot-scope="scope">
              <span v-if="scope.row.gender == 0">女</span>
              <span v-if="scope.row.gender == 1">男</span>
              <span v-if="scope.row.gender == 2">未知</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="phoneNum" label="手机号码"></el-table-column>
          <el-table-column v-if="!id" label="操作" header-align="center" align="center" width="120">
            <template slot-scope="scope">
              <el-button class="btn" v-if="id ? false : true" type="danger" size="" plain @click="handleDel(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="submit" v-if="!id">
      <el-button type="primary" @click="onSubmit">发送</el-button>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="添加联系人" :visible.sync="dialogVisible" width="60%">
      <div class="supplier">
        <div class="s_wrapper">
          <el-input class="s_input" v-model="nickName" placeholder="搜索用户昵称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
          <el-input class="s_input" v-model="userCode" placeholder="搜索用户编号" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
          <el-input class="s_input" v-model="phoneNum" placeholder="搜索手机号码" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        </div>
        <div class="g_table" v-loading="dialogLoading">
          <el-table ref="table2" :data="list" style="width: 100%" max-height="540" row-key="userId" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" reserve-selection></el-table-column>
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
              </template>
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="nickName" label="用户昵称"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="gender" label="用户性别">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 0">女</span>
                <span v-if="scope.row.gender == 1">男</span>
                <span v-if="scope.row.gender == 2">未知</span>
              </template>
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="电话号码">
              <template slot-scope="scope">
                <span>{{ scope.row.phoneNum || "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="注册时间"></el-table-column>
          </el-table>
        </div>

        <el-pagination class="page2" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleContcatList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createdForm() {
  return {
    textName: "",
    text: "",
    userIdList: [],
    msgType: "",
  }
}

export default {
  data() {
    return {
      loading: false,
      dialogLoading: false,
      id: this.$route.query.id,
      ruleForm: createdForm(),
      rules: {
        textName: [{ required: true, message: "请输入内容", trigger: "blur" }],
        text: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      tableData: [],
      nickName: "",
      userCode: "",
      phoneNum: "",
      dialogVisible: false,
      selectList: [],
      list: [],
      msgType: 0, // 0 全部 1 指定
      sendType: 0, // 0 小程序 1 公众号

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    if (this.id) {
      this.getDetail()
    }
  },
  methods: {
    getDetail() {
      this.loading = true
      this.$axios
        .get(this.$api.user_msgselect_store_msg_info, {
          params: {
            id: this.id,
          },
        })
        .then(res => {
          this.ruleForm = res.result
          this.msgType = res.result.msgType
          this.sendType = res.result.sendType
          this.ruleForm.userIdList = res.result.userInfoListVos
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    getList() {
      this.dialogLoading = true
      this.$axios
        .get(this.$api.userInfoList, {
          params: {
            nickName: this.nickName,
            userCode: this.userCode,
            phoneNum: this.phoneNum,
            sendType: this.sendType, // 发送类型 0-小程序 1-公众号
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.list = res.result.list || []
          this.totalItemsCount = res.result.totalCount
          this.dialogLoading = false
        })
        .catch(err => {
          this.dialogLoading = false
          this.$message.error(err.desc)
        })
    },
    onSelect() {
      this.dialogVisible = true
      this.getList()
    },
    handleDel(row) {
      this.ruleForm.userIdList = this.ruleForm.userIdList.filter(item => item.userId != row.userId)
      this.$refs.table2.clearSelection()

      setTimeout(() => {
        this.ruleForm.userIdList.forEach((item, index) => {
          this.$refs.table2.toggleRowSelection(item)
        })
      }, 200)
    },
    onSearch() {
      this.getList()
    },
    handleSelectionChange(array) {
      this.selectList = [...array]
    },
    handleContcatList() {
      if (this.selectList.length == 0) {
        this.$message.error("请选择联系人")
        return
      }
      this.ruleForm.userIdList = [...this.selectList]
      this.dialogVisible = false
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          return false
        }
        if (this.msgType == 1 && this.ruleForm.userIdList.length == 0) {
          this.$message.error("请选择联系人")
          return false
        }

        this.loading = true
        let userIdList = this.msgType == 0 ? null : this.ruleForm.userIdList.map(item => item.userId)
        this.$axios
          .post(this.$api.user_msgsend_user_list_msg, {
            storeId: this.$store.state.userInfo.bizId,
            textName: this.ruleForm.textName, // 消息名称
            text: this.ruleForm.text, // 消息内容
            msgType: this.msgType, // 消息类型 0-全部 , 1-指定
            sendType: this.sendType, // 发送类型 0-小程序 1-公众号
            userIdList, // 联系人ID列表
          })
          .then(res => {
            this.$message.success("群发成功")
            this.loading = false
            setTimeout(() => {
              this.$router.go(-1)
            }, 500)
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.desc)
          })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.add {
  .form {
    margin-top: 20px;
    padding-right: 40px;

    ::v-deep .el-form-item__label {
      color: #101010;
      font-size: 16px;
      padding-right: 30px;
    }

    .is-disabled ::v-deep .el-textarea__inner {
      background: #f5f7fa;
    }
  }

  .divider {
    padding: 0 30px;
  }

  .list {
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding: 0 30px;
      margin-bottom: 30px;
      .left {
        display: flex;
        .label {
          color: #101010;
          font-size: 16px;
        }
        .msg_type {
          margin-left: 30px;
        }
      }
    }
  }
  .search {
    margin-bottom: 20px;
  }
  .submit {
    text-align: center;
    margin-top: 50px;
    .el-button {
      width: 150px;
    }
  }
  .page2 {
    ::v-deep .el-input,
    ::v-deep .el-input__inner {
      width: 50px;
    }
    ::v-deep .el-pagination__sizes {
      .el-input,
      .el-input__inner {
        width: 80px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  max-height: 700px;
}
</style>
